<template>
  <div class="recipe_drug_card">
    <div v-if="orderType === 'CHINESE_RECIPE'" class="pt10 pb10 color_333">
      <div class="flex aic fs13">
        <img src="../../assets/icon/renewal/chineseDrug.png" alt=""/>
        <span class="ml10 overstriking">中药药品</span>
      </div>

      <renewal-drugs-china-drug :drugList="list"></renewal-drugs-china-drug>
      <p class="pt10">贴数：{{ tcmDosage }}</p>
      <p class="pt5">用药方法：{{ info.tcmMethodName || '无' }}</p>
      <p class="pt5">用药频率：{{ info.tcmFrequencyName || '无' }}</p>
      <p class="bb pt5 pb10">医嘱备注：{{ info.remark || '无' }}</p>
    </div>
    <div v-else class="pt10">
      <div class="flex aic fs13 pb10">
        <img src="../../assets/icon/renewal/westDrug.png" alt=""/>
        <span class="ml10 overstriking">西药药品</span>
      </div>
      <recipe-drugs-card-line
          v-for="(item, index) in list" :key="index"
          :info="item">
      </recipe-drugs-card-line>
    </div>
  </div>
</template>

<script>
import RecipeDrugsCardLine from "../renewal/recipe-drugs-card-line";
import RenewalDrugsChinaDrug from "../renewal/renewal-drugs-china-drug";

export default {
  name: "recipe-drugs-card",
  data() {
    return {
      drugList: [],
      drugInfo: this.info,
    }
  },
  props: {
    source: String, //来源
    info: Object,
    list: {
      type: Array,
      default: []
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
  },
  components: {RenewalDrugsChinaDrug, RecipeDrugsCardLine},
  computed: {
    tcmDosage() {
      if (this.$route.query.tcmDosage) {
        return this.$route.query.tcmDosage
      } else {
        return this.info.tcmDosage
      }
    },
    tcmAdmission() {
      if (this.$route.query.tcmAdmission) {
        return this.$route.query.tcmAdmission
      } else {
        return this.info.tcmAdmission
      }
    },
    //处方类型 中药-CHINESE_RECIPE
    orderType() {
      if (this.info && this.info.orderType) {
        return this.info.orderType
      } else if (this.$route.query.orderType) {
        return this.$route.query.orderType
      }
    },
  },
  created() {
    this.drugInfo && (this.drugList = this.drugInfo.list)
  },
  watch: {
    drugInfo(newV) {
      this.drugList = newV.list
    },

    info(newV) {
      this.drugInfo = newV
    },
  }
}
</script>

<style scoped lang="scss">
.recipe_drug_card {
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pill {
    color: #9ad1fe;
  }

  .dash {
    border-top: 1px solid #f1f1f1;
    height: 15px;
  }
}

</style>
